

































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import PdfBarcodeDocument from "../../components/pdf-barcode-document.vue";
import { ApiData } from "@/lib/apiData";
import AppConsts from "@/lib/appconst";
import _ from "lodash";

@Component({
  components: {
    "pdf-barcode-document": PdfBarcodeDocument,
  },
})
export default class PrintCollectionCodes extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  spinShow: boolean = false;
  @Prop({ type: Object, default: new ApiData() }) data: ApiData;
  collectionCodeTypes = AppConsts.collectionCodeTypes;
  collectionCodeType = "";
  get printData() {
    return {
      pages: this.collectionCodeCodes,
      pagesTitle: this.pageTitlePopup,
      objectType: "collectionCode",
    };
  }
  get collectionCodeCodes() {
    return _.map(this.data.pages, this.collectionCodeType);
  }

  get pageTitlePopup() {
    return this.data.pagesTitle;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  async mounted() {
    this.collectionCodeType = "";
  }
  created() {}
  resetFields() {
    this.collectionCodeType = "";
  }
}
